// patch:gowdham:zoho-oauth
import { useCallback } from "react";

import {
  AuthCardButton,
  AuthTextButton,
} from "metabase/auth/components/AuthButton";

interface ZohoButtonProps {
  isCard?: boolean;
  redirectUrl?: string;
}

export const ZohoButton = ({ isCard, redirectUrl }: ZohoButtonProps) => {
  const handleLogin = useCallback(() => {
    const ssoUrl = "/auth/zoho/login";
    const url = redirectUrl
      ? `${ssoUrl}?redirect=${encodeURIComponent(redirectUrl)}`
      : ssoUrl;
    window.location.href = url;
  }, [redirectUrl]);

  const Button = isCard ? AuthCardButton : AuthTextButton;
  return <Button onClick={handleLogin}>Sign in with Zoho</Button>;
};
